/**
 * Capitalizes the first letter of a word and lowercases the rest
 * @param word - The string to capitalize
 * @returns The capitalized string
 */
export const capitalizeFirstLetter = (word: string) => {
   return word.charAt(0).toUpperCase() + word.toLowerCase().slice(1)
}

export * from '@/utilities/scroll-to-section-start'
